import Text from "./text"
import '../../style.scss'
import { enToPersianChar } from "../../../../functions/extensions/enToPersianChar"
import VoiceFile from "./VoiceFile"



type Props = {
    states: any,
}


const InitialMessage = ({ states }: Props) => {
    return (

        <div className="d-flex flex-column justify-content-start align-items-start">

            {JSON.parse(states?.item?.messages)?.map((_item: any, index: number) => {
                return (
                    <>
                        <label className="txt-title ">پیام
                        <span className="m-1">{enToPersianChar(index + 1)}</span> :
                         </label>
                        <div className="initail-txt-wrapper">
                            <VoiceFile item={_item} url={_item?.Url} index={index} />
                            <Text item={_item} />
                        </div>


                    </>

                )
            })}

        </div>
    )
}
export default InitialMessage